import { render, staticRenderFns } from "./TemplateCardSkeleton.vue?vue&type=template&id=34a16a27&scoped=true"
var script = {}
import style0 from "./TemplateCardSkeleton.vue?vue&type=style&index=0&id=34a16a27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a16a27",
  null
  
)

export default component.exports